export class ProgramGradesServed {
    public id: number;
    public preK: boolean;
    public kindergarten: boolean;
    public first: boolean;
    public second: boolean;
    public third: boolean;
    public fourth: boolean;
    public fifth: boolean;
    public sixth: boolean;
    public seventh: boolean;
    public eighth: boolean;
    public ninth: boolean;
    public tenth: boolean;
    public eleventh: boolean;
    public twelvth: boolean;
    public outOfSchoolYouth: boolean;
}


// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/program/program-grades-served.ts